// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".theme--light.v-card>.v-card__text .crud-field{color:rgba(0,0,0,.87)}.detached-label-match{font-size:12px;height:20px;line-height:20px;padding-top:1px;position:relative;z-index:2}.crud-field .v-input__icon--prepend .v-icon{color:rgba(0,0,0,.3)}.v-select__slot{min-height:32px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
